// @ts-nocheck

import {
  ActiveEditorContext,
  BaseElementWidget,
  RowContext,
  SPI,
  TABLE_WIDGET,
  TableEditorTrigger,
  TableWidget,
  ViewType,
  VxeTableHelper,
  Widget,
  TableEditorMode,
  SearchView
} from '@kunlun/dependencies';
import { watch } from 'vue';

@SPI.ClassFactory(
  BaseElementWidget.Token({
    viewType: ViewType.Table,
    widget: ['table', TABLE_WIDGET]
  })
)
export class DefaultTableWidget extends TableWidget {
  constructor() {
    super();
    this.name = 'TableWidget';
  }
  @Widget.Method()
  protected activeEditorBefore(context: ActiveEditorContext): boolean {
    const { field } = context.column;
    let isEnabled = true;
    if (field) {
      const columnWidget = this.getColumnWidgets().find((v) => v.itemData === field);
      if (columnWidget && columnWidget.editable && columnWidget.editorTrigger !== TableEditorTrigger.manual && columnWidget.editorMode === TableEditorMode.cell) {
        const { row, rowIndex, origin } = context;
        isEnabled = columnWidget.cellEditable({
          key: VxeTableHelper.getKey(row),
          data: row,
          index: rowIndex,
          origin
        });
      }
    }
    if (!isEnabled) {
      return false;
    }
    // if (this.tableInstance?.getActiveEditorRecord()) {
    //   return false;
    // }
    return true;
  }

  @Widget.Method()
  @Widget.Provide()
  private async rowEditorClosed(context: RowContext | undefined): Promise<boolean> {
    if (!context) {
      return true;
    }
    if (!this.currentEditorContext?.submit) {
      await this.rowEditorClosedAfterProcess(context);
      this.lastedCurrentEditorContext = undefined;
      return true;
    }
    let res = await this.rowEditorClosedBefore(context);
    if (!res) {
      return false;
    }
    const data = await this.rowEditorClosedForSubmit(context);
    if (this.inline) {
      if (res && data) {
        this.updateSubviewFieldWidget(context, data);
        return true;
      }
    } else if (data) {
      try {
        res = await this.rowEditorClosedForUpdate(context, data);
      } catch (e) {
        console.error(e);
        res = false;
      }
    }
    if (res) {
      await this.rowEditorClosedAfterProcess(context);
      this.lastedCurrentEditorContext = undefined;
    }
    return res;
  }
}

@SPI.ClassFactory(
  BaseElementWidget.Token({
    viewType: ViewType.Table,
    widget: ['table', TABLE_WIDGET],
    inline: true,
    model: 'deli.retail.RetailTakeoutHotPoolItem'
  })
)
export class CardCascaderTableWidget extends DefaultTableWidget {
  mounted() {
    super.mounted();
    watch(
      () => {
        return this.rootData?.[0]?.id;
      },
      (id) => {
        if (id) {
          const sv = this.getParentWidget()
            ?.getChildrenWidget()
            .find((w) => w instanceof SearchView);
          if (sv) {
            const sw = sv.getChildrenWidget()?.[0];
            if (sw) {
              sw.onReset?.();
            }
          }
          this.onPaginationChange(1, this.pagination.pageSize);
        }
      },
      { dee: true }
    );
  }
}
